/**
 * oRPC TanStack Query ユーティリティ
 *
 * appContract のルーター構造がそのまま呼び出しパスになる。
 * 使用例（work-mode の場合）:
 *   const { data } = useQuery(orpc.workMode.list.queryOptions({ input: { ... } }))
 *   const mutation = useMutation(orpc.workMode.create.mutationOptions())
 *   queryClient.invalidateQueries({ queryKey: orpc.workMode.list.key() })
 */
import { createTanstackQueryUtils } from '@orpc/tanstack-query';
import { orpcClient } from './client';
export { orpcClient } from './client';
export const orpc = createTanstackQueryUtils(orpcClient);